import React, { useState } from 'react'
import { Table, Button, Modal, message, Row, Col, Dropdown, Menu } from 'antd'
import { CaretDownOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { useSnapshot } from 'valtio'
import useSWR from 'swr'

import tableStore from '../../lib/store/weight_based_shipping_rule'
import TableFilter from '../../components/TableFilter'
import { serialize } from '../../network/request'
import WeightBasedShippingRuleService from '../../network/services/weightBasedShippingRule'

const WeightBasedShippingRuleTable = ({ total, overridePage }) => {
  const navigate = useNavigate()
  const { state } = useSnapshot(tableStore)
  const [currentFilters, setCurrentFilters] = useState(null)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])

  const { data: response } = useSWR(
    serialize(WeightBasedShippingRuleService.getAll, {
      page: overridePage ?? state.currentPage,
      limit: state.pageSize,
      sort: state.sort ?? 'created_at:desc',
      refresh: state.refresh,
      ...state.filters
    })
  )

  console.log({
    page: overridePage ?? state.currentPage,
    limit: state.pageSize,
    sort: state.sort ?? 'created_at:desc',
    refresh: state.refresh,
    ...state.filters
  })

  const rows = WeightBasedShippingRuleService.toRow(response)

  const rowSelection = {
    selectedRowKeys,
    onChange: (keySelected) => {
      setSelectedRowKeys(keySelected)
    }
  }

  const columns = [
    {
      title: 'Id',
      dataIndex: 'id',
      key: 'id',
      sorter: true
    },
    {
      title: 'Min Weight (g)',
      dataIndex: 'min_weight',
      key: 'min_weight',
      sorter: true,
      render: (value) => `${value} g`
    },
    {
      title: 'Max Weight (g)',
      dataIndex: 'max_weight',
      key: 'max_weight',
      sorter: true,
      render: (value) => `${value} g`
    },
    {
      title: 'Tracking Company',
      dataIndex: 'tracking_company_name',
      key: 'tracking_company_name',
      sorter: true
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
      sorter: true,
      render: (value) => new Date(value).toLocaleString()
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <Button
          type="link"
          onClick={() => navigate(`/dashboard/weight_based_shipping_rule/${record.id}`)}
        >
          Edit
        </Button>
      )
    }
  ]

  const filterColumns = [
    { key: 'id', name: 'Id' },
    { key: 'minWeight', name: 'Min Weight' },
    { key: 'maxWeight', name: 'Max Weight' },
  ]

  const handleTableChange = (pagination, filters, sorter) => {
    if (pagination.current !== state.currentPage) {
      tableStore.state.currentPage = pagination.current
    }

    if (pagination.pageSize !== state.pageSize) {
      tableStore.state.pageSize = pagination.pageSize
    }

    if (sorter.field && sorter.order) {
      const sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
      tableStore.state.sort = `${sorter.field}:${sortOrder}`
    }
  }

  const handleDelete = async () => {
    if (selectedRowKeys.length === 0) {
      message.warning('Please select items to delete')
      return
    }

    Modal.confirm({
      title: 'Are you sure you want to delete the selected items?',
      content: 'This action cannot be undone.',
      onOk: async () => {
        try {
          await Promise.all(selectedRowKeys.map((id) => WeightBasedShippingRuleService.remove(id)))
          message.success('Items deleted successfully')
          setSelectedRowKeys([])
          tableStore.state.refresh = Date.now()
        } catch (error) {
          message.error('Failed to delete items: ' + error.message)
        }
      }
    })
  }

  const menu = (
    <Menu>
      <Menu.Item key="delete" onClick={handleDelete}>
        Delete Selected
      </Menu.Item>
    </Menu>
  )

  return (
    <>
      <Row justify="space-between" style={{ marginBottom: 16 }}>
        <Col>
          {selectedRowKeys.length > 0 && (
            <Dropdown overlay={menu} trigger={['click']}>
              <Button>
                Actions <CaretDownOutlined />
              </Button>
            </Dropdown>
          )}
        </Col>
        <Col>
          <TableFilter
            columns={filterColumns}
            setCurrentFilters={(filters) => {
              setCurrentFilters(filters);
              tableStore.state.filters = filters;
              tableStore.state.currentPage = 1;
            }}
          />
        </Col>
      </Row>

      <Table
        rowSelection={rowSelection}
        columns={columns}
        dataSource={rows}
        pagination={{
          current: state.currentPage,
          pageSize: state.pageSize,
          total: total,
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`
        }}
        onChange={handleTableChange}
        loading={!response}
      />
    </>
  )
}

export default WeightBasedShippingRuleTable
